import React from "react";
import { ArrowLeft, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { contactInfo } from "../data/mock";

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-neutral-light">
      {/* Header */}
      <header className="bg-primary text-white py-6">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <Logo size="small" />
              <span className="font-bold text-lg">Gerüst Sanierung</span>
            </Link>
            <Link
              to="/"
              className="flex items-center gap-2 text-white/80 hover:text-accent transition-colors text-sm"
            >
              <ArrowLeft className="w-4 h-4" />
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-3xl font-bold text-primary mb-8">Impressum</h1>

          {/* Angaben gemäß § 5 TMG */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <div className="text-secondary space-y-1">
              <p className="font-semibold text-primary">Gerüst Sanierung</p>
              <p>Inhaber: Robert Recher</p>
              <p>Griesweg 20</p>
              <p>88457 Kirchdorf an der Iller</p>
              <p className="mt-2">Deutschland</p>
            </div>
          </section>

          {/* Kontakt */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">Kontakt</h2>
            <div className="text-secondary space-y-2">
              <p className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-primary" />
                Telefon: {contactInfo.phone}
              </p>
              <p className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-primary" />
                Mobil: {contactInfo.mobile}
              </p>
              <p className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-primary" />
                E-Mail: {contactInfo.email}
              </p>
            </div>
          </section>

          {/* Werkstatt */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Werkstatt / Betriebsstätte
            </h2>
            <div className="text-secondary space-y-1">
              <p className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-primary mt-1" />
                <span>
                  Sterngasse 5<br />
                  88481 Balzheim<br />
                  (Zufahrt über Brühlweg)
                </span>
              </p>
            </div>
          </section>

          {/* Umsatzsteuer */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Umsatzsteuer-Identifikationsnummer
            </h2>
            <p className="text-secondary">
              Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
              <span className="italic">Auf Anfrage erhältlich</span>
            </p>
          </section>

          {/* Berufsbezeichnung */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Berufsbezeichnung und berufsrechtliche Regelungen
            </h2>
            <div className="text-secondary space-y-2">
              <p>Berufsbezeichnung: Gewerbetreibender / Handwerker</p>
              <p>Zuständige Kammer: Handwerkskammer Ulm</p>
              <p>Verliehen in: Deutschland</p>
            </div>
          </section>

          {/* Verantwortlich für den Inhalt */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <div className="text-secondary space-y-1">
              <p>Robert Recher</p>
              <p>Griesweg 20</p>
              <p>88457 Kirchdorf an der Iller</p>
            </div>
          </section>

          {/* EU-Streitschlichtung */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              EU-Streitschlichtung
            </h2>
            <p className="text-secondary">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-accent underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              <br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          {/* Verbraucherstreitbeilegung */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Verbraucherstreitbeilegung / Universalschlichtungsstelle
            </h2>
            <p className="text-secondary">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen. Unsere Angebote richten sich ausschließlich an Gewerbetreibende (Unternehmer im Sinne des § 14 BGB).
            </p>
          </section>

          {/* Haftung für Inhalte */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Haftung für Inhalte
            </h2>
            <p className="text-secondary">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              <br /><br />
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          {/* Haftung für Links */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Haftung für Links
            </h2>
            <p className="text-secondary">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              <br /><br />
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          {/* Urheberrecht */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Urheberrecht
            </h2>
            <p className="text-secondary">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              <br /><br />
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>

          {/* Hinweis zu reparierten Belägen */}
          <section className="mb-8 bg-accent/10 rounded-xl p-6">
            <h2 className="text-xl font-semibold text-primary mb-4">
              Besonderer Hinweis zu reparierten Gerüstbelägen
            </h2>
            <p className="text-secondary">
              Bei reparierten Gerüstbelägen gelten besondere Rahmenbedingungen: Durch die Reparatur entfällt die ursprüngliche bauaufsichtliche Zulassung. Die instandgesetzten Beläge entsprechen nicht mehr den anerkannten Regeln der Technik (DIN 4420) und dürfen nicht als „DIN 4420" gekennzeichnet werden. Für den Einsatz kann eine baurechtliche Zustimmung im Einzelfall erforderlich sein.
              <br /><br />
              Es wird keine Haftung oder Gewährleistung für von Ihnen selbst oder durch uns reparierte Beläge übernommen. Alle Angebote richten sich ausschließlich an Gewerbetreibende.
            </p>
          </section>

          {/* Stand */}
          <p className="text-sm text-secondary/70 mt-8">
            Stand: August 2025
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-primary text-white py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Gerüst Sanierung – Robert Recher
            </p>
            <div className="flex gap-6">
              <Link to="/" className="text-white/60 hover:text-accent text-sm">
                Startseite
              </Link>
              <Link to="/datenschutz" className="text-white/60 hover:text-accent text-sm">
                Datenschutz
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ImpressumPage;
